import { inject, Injectable } from '@angular/core';
import { FacebookLogin } from '@capacitor-community/facebook-login';
import { Platform } from '@ionic/angular/standalone';
import { isProd } from 'src/app/core/helpers/utils';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SocialMediaService {
  private platform = inject(Platform);

  init() {
    if (!isProd) {
      return;
    }
    this.initFacebook();
    this.injectSnapPixel();
    // this.injectTiktokPixel(); causes significant delay when opening address modals  GET https://analytics.tiktok.com/i18n/pixel/events.js?sdkid=CVI86SJC77U8060QRJ7G&lib=ttq net::ERR_TIMED_OUT
    this.injectTwitterPixel();
    this.injectMetaPixel();
  }

  private initFacebook() {
    this.platform.ready().then(async () => {
      await FacebookLogin.initialize({ appId: '24564767336450040' });
      await FacebookLogin.setAutoLogAppEventsEnabled({ enabled: true });
    });
  }

  private injectSnapPixel() {
    const inlineScript = document.createElement('script');
    inlineScript.innerHTML = `
    (function (e, t, n) {
      if (e.snaptr) return;
      var a = (e.snaptr = function () {
        a.handleRequest ? a.handleRequest.apply(a, arguments) : a.queue.push(arguments);
      });
      a.queue = [];
      var s = "script";
      var r = t.createElement(s);
      r.async = !0;
      r.src = n;
      var u = t.getElementsByTagName(s)[0];
      u.parentNode.insertBefore(r, u);
    })(window, document, "https://sc-static.net/scevent.min.js");
    snaptr("init", '${environment.snapchatPixel}', {});
    snaptr("track", "PAGE_VIEW");
  `;
    document.head.appendChild(inlineScript);
  }

  private injectTiktokPixel() {
    const inlineScript = document.createElement('script');
    inlineScript.innerHTML = `
    !(function (w, d, t) {
      w.TiktokAnalyticsObject = t;
      var ttq = (w[t] = w[t] || []);
      ttq.methods = ["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"];
      ttq.setAndDefer = function (t, e) {
        t[e] = function () {
          t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
        };
      };
      for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
      ttq.instance = function (t) {
        var e = ttq._i[t] || [];
        for (var n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
        return e;
      };
      ttq.load = function (e, n) {
        var r = "https://analytics.tiktok.com/i18n/pixel/events.js",
            o = n && n.partner;
        ttq._i = ttq._i || {};
        ttq._i[e] = [];
        ttq._i[e]._u = r;
        ttq._t = ttq._t || {};
        ttq._t[e] = +new Date();
        ttq._o = ttq._o || {};
        ttq._o[e] = n || {};
        var s = document.createElement("script");
        s.type = "text/javascript";
        s.async = true;
        s.src = r + "?sdkid=" + e + "&lib=" + t;
        var f = document.getElementsByTagName("script")[0];
        f.parentNode.insertBefore(s, f);
      };
      ttq.load('${environment.tiktokPixel}');
      ttq.page();
    })(window, document, "ttq");
  `;
    document.head.appendChild(inlineScript);
  }

  private injectTwitterPixel() {
    const inlineScript = document.createElement('script');
    inlineScript.innerHTML = `
    !(function (e, t, n, s, u, a) {
      e.twq || (
        s = e.twq = function () {
          s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments);
        },
        s.version = "1.1",
        s.queue = [],
        u = t.createElement(n),
        u.async = !0,
        u.src = "https://static.ads-twitter.com/uwt.js",
        a = t.getElementsByTagName(n)[0],
        a.parentNode.insertBefore(u, a)
      );
    })(window, document, "script");
    twq("config", '${environment.twitterPixel}');
  `;
    document.head.appendChild(inlineScript);
  }

  private injectMetaPixel() {
    const inlineScript = document.createElement('script');
    inlineScript.innerHTML = `
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    fbq("init", '${environment.facebookPixel}');
    fbq("track", "PageView");
  `;
    document.head.appendChild(inlineScript);
  }
}
